import { getEndpointPathBuilders } from './endpoint.ts'

const { base, action } = getEndpointPathBuilders('reservations')

export default {
  base,
  byItem: item => action('by-item', { item }),
  byUser: user => action('mine', { user }),
  mine: action('mine'),
  currentBorrowed: action('current-borrowed'),
  future: action('future'),
  history: action('history'),
  create: action('create'),
  confirmBorrowed: action('confirm-borrowed'),
  returnBorrowed: action('return-borrowed'),
  updateState: action('update-state'),
  adminCancel: action('admin-cancel'),
}
